import * as h2Api from '../../h2Api'
import { appendSearchResults, initSearchResults } from '../search'

export const ALL_OCCUPATION_LISTING = 'ALL_OCCUPATION_LISTING'
export const ADD_OCCUPATION_LISTING = 'ADD_OCCUPATION_LISTING'

export const loadAllOccupationListing = filters => dispatch => {
  console.log(filters)

  return dispatch(
    h2Api.post(`/api/v1/occupations/list`, { filters })({ type: ALL_OCCUPATION_LISTING })
  ).then(v => {
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentOccupationsListing = filters => (
  startIdx,
  endIdx
) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/api/v1/occupations/list`, updatedJson)({ type: ADD_OCCUPATION_LISTING })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}
